<template>
  <b-button @click="$emit('click', $event)" size="sm" :variant="variant" v-b-tooltip.hover :title="showToolTip ? tooltip : ''"><i class="fa fa-lg fa-clock-o"></i></b-button>
</template>

<script>

export default ({
  name: "button-clock",

  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    tooltip: {
      type: String,
      default: 'Установить время'
    }
  },

  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
